/* eslint-disable max-len */
import { MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import * as questionIds from "./questionIds";

export const masterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.ServiceRequired,
        questionText: "Please select the relevant service below",
        canBeDisabled: true
    },
    {
        id: questionIds.PrivacyConsent,
        questionText: "I have provided the employee I am referring with access to the <strong><u><a href=\"https://www.tphealth.co.uk/privacy-statement\" target=\"_blank\" rel=\"noopener noreferrer\">Optima Health Privacy Statement</a></u></strong> which clearly explains in detail how, where and when their personal and health data will be processed.",
        canBeDisabled: true
    },
    {
        id: questionIds.EmployeeAwareConsent,
        questionText: "In ticking this box, I confirm that I have made the employee aware that I am making this referral and I can confirm that the employee is aware of the purpose and content of the referral.",
        canBeDisabled: true
    },
    {
        id: questionIds.DataSecureConsent,
        questionText: "I understand that all information about the employee I am referring will be held securely and if the employee wishes to gain access to their medical information they can do so by requesting access in writing to Optima Health.",
        canBeDisabled: true
    },
    {
        id: questionIds.LineManagerName,
        questionText: "Line Manager's Name",
        canBeDisabled: false
    },
    {
        id: questionIds.LineManagerEmail,
        questionText: "Line Manager's Email",
        canBeDisabled: false
    },
    {
        id: questionIds.LineManagerPhone,
        questionText: "Line Manager's Telephone",
        canBeDisabled: false
    },
    {
        id: questionIds.HrName,
        questionText: "HR Representative's Name",
        canBeDisabled: false
    },
    {
        id: questionIds.HrEmail,
        questionText: "HR Representative's Email",
        canBeDisabled: false
    },
    {
        id: questionIds.PurchaseOrderNumber,
        questionText: "Purchase Order Number",
        canBeDisabled: true,
        disabled: true
    },
    {
        id: questionIds.ReferredTitle,
        questionText: "Title",
        canBeDisabled: true
    },
    {
        id: questionIds.ReferredFirstName,
        questionText: "First Name",
        canBeDisabled: false
    },
    {
        id: questionIds.ReferredLastName,
        questionText: "Last Name",
        canBeDisabled: false
    },
    {
        id: questionIds.ReferredDob,
        questionText: "Date of Birth",
        canBeDisabled: false
    },
    {
        id: questionIds.ReferredGender,
        questionText: "Gender",
        canBeDisabled: true
    },
    {
        id: questionIds.EmployeeId,
        questionText: "Employee Unique Id",
        canBeDisabled: false
    },
    {
        id: questionIds.JobTitle,
        questionText: "Job Role/Title",
        canBeDisabled: true
    },
    {
        id: questionIds.AddressLine1,
        questionText: "Address Line 1",
        canBeDisabled: true
    },
    {
        id: questionIds.AddressLine2,
        questionText: "Address Line 2",
        canBeDisabled: true
    },
    {
        id: questionIds.AddressLine3,
        questionText: "Address Line 3",
        canBeDisabled: true
    },
    {
        id: questionIds.City,
        questionText: "City",
        canBeDisabled: true
    },
    {
        id: questionIds.County,
        questionText: "County",
        canBeDisabled: true
    },
    {
        id: questionIds.Postcode,
        questionText: "Postcode",
        canBeDisabled: false
    },
    {
        id: questionIds.PersonalEmailAddress,
        questionText: "Email (Work or Personal)",
        canBeDisabled: false
    },
    {
        id: questionIds.ConfirmPersonalEmailAddress,
        questionText: "Confirm email address",
        canBeDisabled: false
    },
    {
        id: questionIds.MobilePhone,
        questionText: "Mobile Telephone",
        canBeDisabled: true
    },
    {
        id: questionIds.HomePhone,
        questionText: "Home Telephone",
        canBeDisabled: true
    },
    {
        id: questionIds.WorkPhone,
        questionText: "Work Telephone",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel1Name,
        questionText: "Org Level 1",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel2Name,
        questionText: "Org Level 2",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel3Name,
        questionText: "Org Level 3",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel4Name,
        questionText: "Org Level 4",
        canBeDisabled: true
    },
    {
        id: questionIds.ShiftPattern,
        questionText: "Shift Pattern",
        canBeDisabled: true
    },
    {
        id: questionIds.StandardHours,
        questionText: "Standard Hours per Week",
        canBeDisabled: true
    },
    {
        id: questionIds.TotallyConfidential,
        questionText: "Mark as totally confidential",
        canBeDisabled: true
    },
    {
        id: questionIds.SupportingDocumentsHeader,
        questionText: "Please attach any further relevant information such as absence history or completed risk assessments here to support your referral.  Please note, any uploaded documents will show on the documents tab in the case after submission.",
        canBeDisabled: false
    },
    {
        id: questionIds.FurtherInformation,
        questionText: "Please provide any additional information",
        canBeDisabled: true
    },
];
/* eslint-enable max-len */
